/**
 * reportWebVitals.js — Core Web Vitals performance reporter
 * ===========================================================
 * Dynamically imports the `web-vitals` library and registers callbacks
 * for the five standard metrics.  The library is loaded lazily so it does
 * not bloat the initial bundle.
 *
 * Metrics collected
 * ------------------
 * CLS  — Cumulative Layout Shift       (visual stability)
 * FID  — First Input Delay             (interactivity)
 * FCP  — First Contentful Paint        (loading speed)
 * LCP  — Largest Contentful Paint      (loading speed)
 * TTFB — Time To First Byte            (server response speed)
 *
 * Usage
 * -----
 * Pass a function to log or forward metrics:
 *   reportWebVitals(console.log)
 *   reportWebVitals(metric => sendToAnalytics(metric))
 *
 * If no callback is provided (as in the default setup), this is a no-op.
 */

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Lazy-load web-vitals to keep it out of the critical bundle
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);   // Cumulative Layout Shift
      getFID(onPerfEntry);   // First Input Delay
      getFCP(onPerfEntry);   // First Contentful Paint
      getLCP(onPerfEntry);   // Largest Contentful Paint
      getTTFB(onPerfEntry);  // Time To First Byte
    });
  }
};

export default reportWebVitals;
